export enum InteractiveQuestionType {
  Quiz = 'QUIZ_ACTIVITY',
  OpenAnswer = 'OPEN_ANSWER_ACTIVITY',
  TrueFalse = 'TRUE_FALSE_ACTIVITY',
  Image = 'IMAGE_ACTIVITY',
  Sort = 'SORT_ACTIVITY',
  Survey = 'SURVEY_ACTIVITY',
  FillInTheBlanks = 'FILL_IN_THE_BLANKS_ACTIVITY',
  ShortAnswer = 'SHORT_ANSWER_ACTIVITY',
  ImageSurvey = 'IMAGE_SURVEY_ACTIVITY',
}
